import { SxProps } from "@mui/material";
import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";
import React from "react";

type DatagridDisplayProps = {
  isLoading?: boolean;
  rows: any[];
  columns: GridColDef[];
  disableRowSelectionOnClick?: boolean;
  disableColumnSelector?: boolean;
  onRowClick?: GridEventListener<"rowClick">;
  className?: string;
  sx?: SxProps;
};

const DatagridDisplay: React.FC<DatagridDisplayProps> = ({
  columns,
  isLoading,
  rows,
  disableRowSelectionOnClick = false,
  disableColumnSelector = false,
  onRowClick,
  className,
  sx,
}) => {
  return (
    <DataGrid
      className={className}
      rowSelection={false}
      onRowClick={onRowClick}
      disableRowSelectionOnClick={disableRowSelectionOnClick}
      disableColumnSelector={disableColumnSelector}
      hideFooter
      sx={sx}
      loading={isLoading}
      columns={columns}
      rows={rows}
    />
  );
};

export default DatagridDisplay;
